module.exports = __webpack_public_path__ + "logos/logo-default.ee69fb.svg";